import fetch from '@/utils/fetch';

export function affSave(query) {
    return fetch({
        url: '/Zhengwu/Zhengwu/saveHandleMatters',
        method: 'post',
        data: query
    });
}

export function affLocs(query) {
    return fetch({
        url: '/Zhengwu/Zhengwu/batchSaveHandleAddress',
        method: 'post',
        data: query
    });
}

export function affConditions(query) {
    return fetch({
        url: '/Zhengwu/Zhengwu/batchSaveAcceptanceConditions',
        method: 'post',
        data: query
    });
}

export function addHandles(query) {
    return fetch({
        url: '/Zhengwu/Zhengwu/batchSaveProcessConditions',
        method: 'post',
        data: query
    });
}

export function affPgress(query) {   // 办理流程
    return fetch({
        url: '/Zhengwu/Zhengwu/batchSaveProcessFlow',
        method: 'post',
        data: query
    });
}

export function affFiles(query) {   // 申请材料
    return fetch({
        url: '/Zhengwu/Zhengwu/batchSaveApplicationMaterials',
        method: 'post',
        data: query
    });
}

export function affList(query) {
    return fetch({
        url: '/Zhengwu/Zhengwu/getChildHandleMattersList',
        method: 'post',
        data: query
    });
}

export function affRemove(query) {
    return fetch({
        url: '/Zhengwu/Zhengwu/batchDeleteHandleMatters',
        method: 'post',
        data: query
    });
}

export function affStatusSet(query) {
    return fetch({
        url: '/Zhengwu/Zhengwu/updateStatusHandleMatters',
        method: 'post',
        data: query
    });
}

export function getAffair(query) {   // 获取详情
    return fetch({
        url: '/Zhengwu/Zhengwu/getManageHandleMattersById',
        method: 'post',
        data: query
    });
}


export function getUpList(query) {   // 上级事项列表
    return fetch({
        url: '/Zhengwu/Zhengwu/getParentHandleMattersList',
        method: 'post',
        data: query
    });
}

export function getpGress(query) {   // 获取办理流程
    return fetch({
        url: '/Zhengwu/Zhengwu/getProcessFlowByCqjZhengwuHandleMattersId',
        method: 'post',
        data: query
    });
}



// WEBPACK FOOTER //
// ./src/api/affairs/affairs.js